
import colors from 'core/resources/theme/colors';

export function getLabelAcaoAuditoria(event: string) {
    if (!event) {
        return "";
    }

    if (event.includes("atualiz")) {
        return "Atualização";
    }
    if (event.includes("criad")) {
        return "Criação";
    }
    if (event.includes("cancel")) {
        return "Cancelamento"
    }
    if (event.includes("exclu") || event.includes("delet")) {
        return "Exclusão";
    }
    return ""
}

export function getColorAcaoAuditoria(event: string) {
    if (!event) {
        return colors.accentBlue;
    }
    
    if (event.includes("atualiz")) {
        return colors.accentBlue;
    }
    if (event.includes("criad")) {
        return colors.green;
    }
    if (event.includes("exclu") || event.includes("delet") || event.includes("cancel")) {
        return colors.red;
    }

    return colors.accentBlue;
}